import { taskGroupsFeature } from './task-groups.reducer';

const { selectTaskGroups } = taskGroupsFeature;

export const TaskGroupsSelectors = {
  selectTaskGroups,
};
